var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDitpIsoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 99,
    viewBox: "0 0 515 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.85 98.11H0V50.18L16.34 33.99V30.1H0V11.29H59.48C85.29 12.83 100.55 24.01 101.85 50.8C103.06 75.9 94.31 92.63 68.44 97.03L60.85 98.11ZM22.88 79.29H55.69C65.36 78.53 74.88 76.07 77.76 65.68C79.25 60.31 79.29 47.94 77.56 42.66C74.3 32.72 64.48 30.93 55.2 30.09H22.88V79.28V79.29Z",
    fill: "#0B459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.51 97.86H281.88V49.05L297.97 32.99V29.35H281.88V11.29H354.69C371.46 12.16 382.81 21.15 383.73 38.51C384.71 56.86 374.99 69.83 356.18 71.01C339.64 72.05 322.03 70.24 305.38 71C305.12 70.95 304.51 71.18 304.51 71.39V97.86ZM304.51 53.2H351.66C352.96 53.2 356.36 51.8 357.44 50.94C361.69 47.51 361.94 37.29 358.94 33.15C356.08 29.19 351.41 29.44 347.15 29.38C332.94 29.2 318.72 29.49 304.52 29.37V53.21L304.51 53.2Z",
    fill: "#0B459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.03 11.04V29.86H225.3V97.86H202.42V42.53C203.26 41.27 211.47 34.14 211.47 33.5V29.86H162.94V11.04H265.03Z",
    fill: "#0B459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09 11.04V97.86H123.58C123.58 97.86 123.2 97.51 123.2 97.48V49.55C128.3 44.21 133.6 39.01 138.9 33.85C139.98 32.69 139.42 31.04 139.54 29.6H123.57C123.57 29.6 123.19 29.25 123.19 29.22V11.42C123.19 11.42 123.54 11.04 123.57 11.04H146.08H146.09Z",
    fill: "#0B459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.97 0L511.72 17.45L452.88 27.61C452.55 28.75 454.37 34.71 453.73 35.15L411.63 42.4L414.83 25.08L450.83 18.79C451.14 17.64 449.28 11.68 450.01 11.27L514.97 0Z",
    fill: "#BA0E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.92 55.46L501.86 72.73L462.19 79.56C461.78 79.98 463.49 85.98 463.15 87.04L401.83 97.61L405.02 80.34L460.01 70.77C460.75 70.37 458.8 64.39 459.19 63.26L504.93 55.46H504.92Z",
    fill: "#BA0E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.95 27.35L506.74 44.67L457.4 53.2L458.65 60.72L406.85 69.51L409.85 52.3L455.63 44.41L454.4 36.9L509.95 27.35Z",
    fill: "#0B459B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 514.97,
    height: 98.11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDitpIsoLogo);
export default __webpack_public_path__ + "static/media/ditpIsoLogo.6480d1db12abffe9e56eb467d2467133.svg";
export { ForwardRef as ReactComponent };